import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const DoctorCard = ({ name, title, image, bio, onReadMore }) => {
  return (
    <Card className="text-center hover:shadow-xl transition-shadow duration-300">
      <CardContent className="p-6">
        <div className="mb-4 flex justify-center">
          <div className="relative w-48 h-56 rounded-full overflow-hidden border-4 border-teal-200">
            <img
              src={image}
              alt={`${name} - ${title} at Fort Worth Dental`}
              className="w-full h-full object-cover object-top"
              style={{ objectPosition: 'center 20%' }}
              loading="lazy"
              width={192}
              height={224}
            />
          </div>
        </div>
        <h3 className="text-xl font-bold text-gray-800 mb-2">{name}</h3>
        <p className="text-teal-600 font-medium mb-3">{title}</p>
        <p className="text-gray-600 text-sm mb-4 line-clamp-3">{bio}</p>
        {onReadMore && (
          <Button
            onClick={onReadMore}
            className="bg-teal-600 hover:bg-teal-700 text-white min-h-[44px] min-w-[44px] text-sm"
          >
            Read About {name}
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default DoctorCard;